/**
 * /devhub/inbox — Operator inbox (notifications + secret requests). Surface Layer (/01).
 *
 * REQ-001.91 DevHub UI rebuild · Phase 2 (already-live domains). The operator-scoped notification
 * centre (live `/api/notifications` ack/act/archive via `ScopedNotificationCenter scope="devhub"`)
 * plus the live secret-request inbox (the `secret_requests` RLS table). Operator-only.
 */

import { InlineNotification } from '@carbon/react';
import { createFileRoute } from '@tanstack/react-router';

import { useEntitlements } from '@lib/persistence/useEntitlements';
import { ScopedNotificationCenter } from '../components/notifications/ScopedNotificationCenter';
import { SecretRequestInboxPanel } from '../features/secrets/SecretRequestInboxPanel';

export const Route = createFileRoute('/devhub/inbox')({ component: DevHubInboxPage });

function DevHubInboxPage() {
  const { isElevated } = useEntitlements();

  if (!isElevated) {
    return (
      <main className="view">
        <InlineNotification
          kind="warning"
          lowContrast
          hideCloseButton
          title="Operator access required"
          subtitle="The operator inbox is operator-only."
        />
      </main>
    );
  }

  return (
    <main className="view">
      <header className="view__header">
        <h1 className="view__title">Inbox</h1>
        <p className="view__subtitle">Approval, guardrail and reindex notices, plus secret requests.</p>
      </header>

      <section className="view__section">
        <ScopedNotificationCenter scope="devhub" limit={20} />
      </section>

      <section className="view__section">
        <SecretRequestInboxPanel />
      </section>
    </main>
  );
}
